import {
    ButtonBase,
    Grid,
    Modal,
    Snackbar,
    Typography,
    withStyles,
    withRouter,
    List
} from '../../../material-ui';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { MovieChatItem } from '.';
import AppUtils from '../../../control/apputlis';
import DateUtils from '../../../control/dateutils';
import DeviceEventEmitter, { EventName } from '../../../control/event';
import FIMUtils from '../../../im/FIMUtils';
import AppData from '../../../model/AppData';
import IMApp from '../../../net/IMApp';
import IMEventEmitter, { IMEvent } from '../../../net/IMEventEmitter';
import MessageType from '../../../net/IMMessageType';
import Apis from '../../../network/Apis';
import MChatModal from '../../view/MChatModal';
import MEnvelope from '../../view/MEnvelope';
import Marquee from './animateText/marquee';
import { OpenBrowser } from '../../../control/ToName';


const ICON_FACE = require("../../../images/icons/biaoqing.png");
// const fenxiang = require("../../../images/icons/fenxiang_icon.png");
const SendBtn = require("../../../images/icons/sendBtn.png");

// const MSG_ON = require("../../../images/icons/ic_block_gift_off.png");
// const MSG_OFF = require("../../../images/icons/ic_block_gift_on.png");
// const ICON_COMING = require("../../../images/icons/aixin_icon.png");
const ICON_Loding = require("../../../images/icons/roomLoding.gif");

const Popup0 = require("../../../images/icons/showPopup0.png");
const Popup1 = require("../../../images/icons/showPopup1.png");
const Popup2 = require("../../../images/icons/showPopup2.png");

// const ICON_PRIVATE = require("../../../images/icons/sixin_icon1.png");
const downApp = require("../../../images/icons/downApp.png");
const playBottomMsg = require("../../../images/icons/playBottomMsg.png");
const playUoTips = require("../../../images/icons/playUoTips.png");
const iconOff = require("../../../images/icons/icon_off.png");
// const ICON_COPY = require("../../../images/icons/fuzhi_icon1.png");
// const ICON_SHARE = require("../../../images/icons/fenxiang_icon1.png");


// const SYS_TIPS = '系统提示：本直播努力营造积极健康的直播环境，对直播内容进行24小时巡查， 任何传播违法、违规、诈骗、低俗不良、血腥暴力封建迷信等信息的行为一经发 现，将对违规者账号予以封号处理。';

class MovieChat extends React.Component {

    static nickName = '';

    constructor(props) {
        super(props);

        let { matchId, matchType, room_id } = this.props.match.params;
        let { data } = this.props;
        this.roomId = room_id;
        this.matchType = matchType;
        this.matchId = matchId;
        if (this.matchType == 0) {
            this.matchType = data.match_type;
        }
        if (this.matchId == 0) {
            this.matchId = data.match_id;
        }
        if (this.roomId == 0) {
            this.roomId = data.room_id;
        }
        if (data && data.groupId) {
            console.log('房间里的groupId', data.groupId);
            this.groupId = data.groupId;
        }

        this.state = {
            data: [],
            value: '',
            chatRoomId: this.groupId,
            open: false,
            isRefreshing: false,
            showBarrage: true,
            onsend10: true,
            isTextLoding: true,
            //还没获取历史记录
            getHistory: true,
            showPopup: false,
            snackopened: false,
            snackmessage: '',
            copy_content: this.props.copyContent,
            vhHeight: 'calc(100vh - 56vw - 133px)',
            showUpTips: true,
            showDownload: false,
            showAppDown: true,

        };
        this.showDownLoad = this.isWebClip()
        this.openTime = DateUtils.getCurTime();
    }




    componentDidMount() {
        //是否苹果浏览器
        if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !this.isWebClip()) {
            // this.state.vhHeight = 'calc(100vh - 56vw - 133px - 75px)'
            this.setState({
                vhHeight: 'calc(100vh - 56vw - 133px - 70px)',

            })
        }
        IMEventEmitter.on(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        IMEventEmitter.on(IMEvent.S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP, this.onListory, this);
        IMEventEmitter.on(IMEvent.S2C_MSG_DEL_CHATROOM_MSG_REP, this.delMsg, this);
        IMEventEmitter.on(IMEvent.EVENT_MESSAGE_AD_CHAT, this.onAdChat, this);
        //加入房间成功的通知
        IMEventEmitter.on(IMEvent.JOIN_ROOM_CHAT_REP, this.joinMathGroupResult, this);
        IMEventEmitter.on(IMEvent.S2C_MSG_SEND_CHATROOM_AD_REP, this.onChatRoomAdRep, this)
        IMEventEmitter.on(IMEvent.REF_ROOM, this.connect, this);


        try { this.getMatchGroup(); } catch (error) {
            console.log("加入聊天室失败=====》");
        }
        this.setTime()
        this.changeUpTips()
    }

    changeUpTips = () => {
        setTimeout(() => {
            this.setState({
                showUpTips: false
            })
            console.log(this.state.showUpTips);

        }, 1000 * 3)
    }

    isWebClip = () => {
        let { os } = this.props.match.params;
        let webclip = AppUtils.getQueryVariable('webclip');
        if (webclip && webclip == 1 || os == "ios" || AppUtils.isWebClip) {
            return true;
        }
        return false;
    }
    //socket连接上了，通知回来,去加入房间
    connect = () => {
        this.getMatchGroup();
    }

    delMsg = (msg) => {
        let index = msg.msgno;
        let { data } = this.state;
        for (let i = 0; i < data.length; i++) {
            if (data[i].chatmsgno == index) {

                data.splice(i, 1);
                this.setState({})
            }

        }
    }

    setTime = () => {
        //10分钟后，发送一下服务器
        setTimeout(() => {
            this._sendServer(3)
        }, 1000 * 600)
    }

    componentWillUnmount() {
        this.setState = () => false;
        IMEventEmitter.off(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        IMEventEmitter.off(IMEvent.S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP, this.onListory, this);
        IMEventEmitter.off(IMEvent.REF_ROOM, this.connect, this);
        IMEventEmitter.off(IMEvent.JOIN_ROOM_CHAT_REP, this.joinMathGroupResult, this);
        IMEventEmitter.off(IMEvent.S2C_MSG_DEL_CHATROOM_MSG_REP, this.delMsg, this);
        IMEventEmitter.off(IMEvent.S2C_MSG_SEND_CHATROOM_AD_REP, this.onChatRoomAdRep, this)
        IMEventEmitter.off(IMEvent.EVENT_MESSAGE_AD_CHAT, this.onAdChat, this);
        const { chatRoomId } = this.state;
        if (chatRoomId && chatRoomId.length > 0) {
            FIMUtils.quitGroup(chatRoomId);
        }
    }

    onAdChat = (e) => {
        AppUtils.YMPush("MAIN", "发送群发")
    }

    onChatRoomAdRep = (e) => {
        console.log("onChatRoomAdRep", e)
        if (e.roomkey = this.roomId) {
            AppUtils.YMPush("MAIN", "发送聊天广告")
            let messageAd = JSON.parse(e.content);
            if (messageAd.adType == 1) {
                messageAd.msgtype = MessageType.AD;
                this.state.data.push(messageAd);
                this.setState({ data: this.state.data }, () => {
                    this.scrollToBottom();
                });
            }
        }
    }

    getGroupHistoryMessageList = async (chatRoomId) => {
        try {
            let result = await FIMUtils.getConversationMessageList(chatRoomId);
            console.log('getGroupHistoryMessageList', result);
            for (let i = 0; i < result.length; i++) {
                this.state.data.push(result[i]);
            }

            this.setState({ data: this.state.data }, () => {
                this.scrollToBottom(); 
            });
        } catch (error) {

        }
    }

    //获取聊天室历史记录
    getHistory = (roomId) => {
        IMApp.getRoomHistoryMsg(roomId)
    }

    //接收聊天室历史记录
    onListory = (historyData) => {

        const { data } = this.state;
        if (data.length > 0) {
            return;
        }
        if (data.length == 0) {
            data.push({
                msgtype: 10010
            })
        }
        this.onMessageReceived(historyData)

        let { marquee } = this.props;
        if (marquee && marquee.private_status == 1 && marquee.private_info.length > 0) {
            AppUtils.YMPush("MAIN", "发送欢迎语")
            this.state.data.push({ url: marquee.private_url, img: marquee.private_img, title: marquee.private_title, content: marquee.private_info, msgtype: MessageType.AD })
        }
    }

    scrollToBottom = () => {
        if (this.listView) {
            AppUtils.YMPush("DOWNLOAD", "滑动聊天")
            this.listView.scrollIntoView()
        }
    }

    //接收到消息
    onMessageReceived = (msgs) => {
        // msgtype 
        const { data } = this.state;

        if (msgs) {
            let { tdata } = this.props;
            const chatRoomId = tdata.groupId

            console.log('房间id记录', msgs);
            console.log('接收到房间记录id', chatRoomId);
            for (let i = 0; i < msgs.length; i++) {
                if (msgs[i].chatkey != chatRoomId || msgs[i].content.length == 0) {
                    continue
                }
                // if (msgs[i].nickname.length > 10) {
                //     msgs[i].nickname = msgs[i].nickname.substr(0, 10);
                // }

                //如果是文本类型
                if (FIMUtils.isMessageText(msgs[i].msgtype)) {
                    // if (isListory) {
                    //     msgs[i].content = StringUtils.decode(msgs[i].content)
                    //     msgs[i].nickname = StringUtils.decode(msgs[i].nickname)
                    // }

                    data.push(msgs[i]);
                    if (this.state.showBarrage && msgs[i].content) {
                        DeviceEventEmitter.emit(EventName.EVENT_BARRAGE_MSG, msgs[i].content);
                    }
                } else if (FIMUtils.isMessageImage(msgs[i].msgtype)) {
                    //如果是图片类型
                    data.push(msgs[i]);
                    if (this.state.showBarrage && msgs[i].content) {
                        DeviceEventEmitter.emit(EventName.EVENT_BARRAGE_MSG, msgs[i].content);
                    }
                }
            }
        }

        this.setState({ data: data }, () => {
            this.scrollToBottom();
        });
    }
    //成功加入聊天室
    joinMathGroupResult = async (joinResult) => {
        if (joinResult.result == 1 || joinResult.result == 35) {
            const { chatRoomId } = this.state;
            this.getGroupHistoryMessageList(chatRoomId);
            this._enterChatRoom(chatRoomId);
            this.setState({
                isTextLoding: false
            })
            this.getHistory(joinResult.room_info.roomkey)
        } else {
            this.setState({ snackopened: true, snackmessage: '聊天室加入失败' })
        }
    }
    //加入聊天室
    getMatchGroup = async () => {
        const { chatRoomId } = this.state;
        console.log('getMatchGroup', chatRoomId);

        if (chatRoomId && chatRoomId != '') {
            let joinResult = await FIMUtils.joinGroup(chatRoomId); //加入房间 
            // console.log('joinResult=========》', joinResult);
            // if (joinResult.result == 1 || joinResult.result == 35) {
            //     this.getGroupHistoryMessageList(chatRoomId);
            //     this._enterChatRoom(chatRoomId);
            //     this.setState({
            //         isTextLoding: false
            //     })
            //     this.getHistory()
            // }
        } else {
            if (this.matchType && this.matchId) {
                let result = await Apis.encryptionMatchGroup(this.matchType, this.matchId);
                console.log('getMatchGroup', result);
                if (result.code == 200) {
                    this.setState({ chatRoomId: result.data });
                    let joinResult = await FIMUtils.joinGroup(result.data);
                    console.log('joinResult', joinResult);
                    if (joinResult.code == 0) {
                        this.getGroupHistoryMessageList(result.data);
                        this._enterChatRoom(result.data);
                    }
                }
                this.getHistory()
            }
        }
    }


    _enterChatRoom = async (chatRoomId) => {
        let nickname = MovieChat.nickName;
        if (!nickname || !chatRoomId) return;
        let result = await Apis.encryptionInGroup(nickname, chatRoomId);
        if (result.code == 200) {
            console.log('_enterChatRoom', result);
        }
    }


    _onClickMsg = () => {
        const { chatRoomId, value } = this.state;
        this._sendTextMessage(chatRoomId, value);
        this.setState({ value: '' });
        window.scroll(0, 10000);

    }

    _handleChange = (value) => {
        this.setState({ value: value, open: false });
    }

    _handleClose = () => {
        console.log('_handleClose');
        this.setState({ open: false });
    }

    //发送文字
    _sendTextMessage(chatRoomId, message) {
        // if (!AppData.me.isLogin() && !this.isWebClip()) {
        //     DeviceEventEmitter.emit(EventName.EVENT_SHOW_DOWNLOAD);
        //     return;
        // }


        let nowTime = DateUtils.getCurTime();
        let timeNum = 0;

        if (AppData.ServerConfig.chat_interval_time) {
            timeNum = parseInt(AppData.ServerConfig.chat_interval_time)
        }

        if (nowTime - this.sendtime < timeNum) {
            this.refs.toast.show('聊天太过频繁，请稍后尝试~');
            return;
        }

        if (!message || message == '') {
            return;
        }
        AppUtils.YMPush("DOWNLOAD", "聊天框发言")
        //处理文字
        message = AppData.keywordShield(message);
        FIMUtils.sendChatRoomMessage(chatRoomId, message);


        this._sendServer(2);

        this.setState({ data: this.state.data }, () => {
            this.scrollToBottom();
        });

        this.sendtime = DateUtils.getCurTime();
    }

    //用户观看10分钟，或聊天调用
    _sendServer = async (type) => {
        if (!this.state.onsend10) return
        if (!AppData.me.isLogin()) return;
        let result = await Apis.get('app/userLookOrSend', {
            type
        })
        this.state.onsend10 = false;

    }

    _onSendMsg = (dom) => {
        let message = '';
        for (let i = 0; i < dom.childNodes.length; i++) {
            let child = dom.childNodes[i];
            if (child.nodeName == 'IMG') {
                message += child.alt;
            } else if (child.nodeName == '#text') {
                message += child.nodeValue;
            }
        }
        const { chatRoomId } = this.state;
        this._sendTextMessage(chatRoomId, message);
        this.setState({ open: false });

        AppUtils.YMPush('DOWNLOAD', 'sendMsg');
    }

    _showChatPanel = () => {
        this.setState({ open: true });  //打开表情
        // IMEventEmitter.emit('MoviePlayerPostButton', false);
    }

    _showBarrage = () => {
        let showBarrage = !this.state.showBarrage;
        this.setState({ showBarrage: showBarrage });
        console.log('showBarrage', showBarrage);
        DeviceEventEmitter.emit(EventName.EVENT_SHOW_BARRAGE, showBarrage);
    }

    _renderFooter() {
        return (
            <Grid ref={el => this.listView = el} container direction='row' style={{ width: '100vw', height: 30, marginBottom: 60 }}>
                <Grid style={{ backgroundColor: 'tranparent', flex: 1, position: 'relative' }}>
                    <Marquee />
                </Grid>
            </Grid>
        );
    }

    _renderItem = (data, rowID) => {
        return (
            <MovieChatItem key={rowID} data={data} />
        );
    }

    _showFenXiang = () => {

        this.setState({
            showPopup: true,
        });
    }
    onClose = () => {
        console.log("关闭了");
        this.setState({
            showPopup: false,
        });
    }

    _onClickMessage() {
        let roomData = this.props.roomData;

        if (AppData.os == 'ios') {
            const { free_id } = roomData
            let data = { "uid": free_id }
            if (window && window.webkit && window.webkit.messageHandlers) {
                window.webkit.messageHandlers.ChatAnchor.postMessage(JSON.stringify(data));
            }
        } else {
            let data = roomData;
            let userId = FIMUtils.createChatKey(data.free_id);//data.uid; 
            this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: data.nickname });
            AppUtils.YMPush("CHAT", "私信主播")
        }
    }
    _onSnackClosed() {
        this.setState({
            snackopened: false,
        });
    }

    onCopy = () => {
        this.setState({ snackopened: true, snackmessage: '复制成功,快去添加吧' })
    }

    toDown = () => { 
        OpenBrowser(AppData.ShareUrl)
        AppUtils.YMPush("DOWNLOAD", "APP下载")
    }

    onCloseApp = () => {
        this.setState({ showAppDown: false })
    }

    onPrivateClick = () => {
        this.setState({ snackopened: true, snackmessage: '复制成功,快去添加吧' })
        // const { roomData } = this.state;
        // this.props.history.push({ pathname: '/privateletter/' + roomData.user_id + '/userProfile', data: roomData.nickname });
    }




    render() {
        const { classes } = this.props;
        const { data, value, open, snackopened, snackmessage, copy_content, vhHeight, showAppDown } = this.state;

        return (
            <Grid container direction='column' alignItems='center' justifycontent='center' className={classes.root}>
                <Grid container direction='column' >
                    {/* <Typography style={{ color: '#878787', fontSize: 10, maxWidth: '100%' }}>
                        <TextScroll content={SYS_TIPS}></TextScroll> 
                    </Typography> */}

                    {/* {球队点赞} */}

                    {/* <ZanPage team={this.props.team} data={this.props.tdata} /> */}

                    {/* 上下跑马灯 */}

                    {/* <Grid container direction='row' style={{ width: '100vw' }}>
                        <Grid className={classes.back}>
                            <Marquee />

                        </Grid>

                    </Grid> */}

                    {
                        this.state.isTextLoding && <div style={{ marginLeft: 10, marginTop: 10, display: 'flex', alignItems: 'center', }}>
                            <img src={ICON_Loding} height={25}></img>
                            <div style={{ marginLeft: 10, fontSize: 12, color: '#919191' }}>聊天正在加载中...</div>
                        </div>
                    }



                </Grid>
                <Grid container direction='column' style={{ width: '100vw', minHeight: vhHeight, }}>
                    {
                        data.map((item, i) => this._renderItem(item, i))
                    }
                    {
                        this._renderFooter()
                    }
                    <Grid container alignItems='center' direction='column' className={classes.copyButtonGrid}>
                        {/* {
                            <Grid container alignItems='center' direction='column'>
                                <ButtonBase className={classes.copyButton} onClick={() => this._onClickMessage()}>
                                    <img src={ICON_PRIVATE} style={{ width: 42, height: 50 }}></img>
                                </ButtonBase>
                            </Grid>
                        } */}
                        <MEnvelope />

                        {((!this.showDownLoad) && showAppDown) &&
                            <Grid container alignItems='center' direction='row'>
                                <ButtonBase className={classes.copyButton} onClick={() => this.toDown()}>
                                    <img src={downApp} style={{ width: 60, height: 60, marginTop: 30 }}></img>
                                </ButtonBase>
                                <ButtonBase className={classes.closeButton} onClick={() => this.onCloseApp()}>
                                    <img src={iconOff} style={{ width: 15, height: 15 }}></img>
                                </ButtonBase>
                            </Grid>
                        }




                    </Grid>
                </Grid>
                {
                    this.state.showUpTips && <div style={{ display: 'flex', justifyContent: 'space-between', width: "100vw", height: 25, position: 'fixed', bottom: 45 }}>
                        <div></div>
                        <img src={playUoTips} style={{ height: 25, marginRight: 60 }}></img>
                    </div>
                }

                <div className={classes.bottomView} style={{ backgroundColor: '#FFF', height: 45, position: 'fixed', bottom: 0 }}>

                    <Grid container direction='row' style={{ flexWrap: 'nowrap' }} alignItems='center' justifycontent='space-between' className={classes.inputBack}>
                        <input
                            value={value}
                            onChange={(e) => this._handleChange(e.target.value)}
                            className={classes.input}
                            placeholder='球要一起聊才high～'>

                        </input>
                        <div onClick={() => this._showChatPanel()} className={classes.iconButton}>
                            <img src={ICON_FACE} style={{ width: 22, height: 22 }}></img>
                        </div>
                    </Grid>

                    <img src={playBottomMsg} onClick={() => this._onClickMessage()} style={{ width: 32, height: 32, marginLeft: 8, marginRight: 8 }}></img>
                    <Grid container style={{ width: 78 }}>
                        <ButtonBase onClick={() => this._onClickMsg()} className={classes.sendMsg}>
                            <img src={SendBtn} style={{ width: 70, height: 32, marginRight: 8 }}></img>
                        </ButtonBase>
                    </Grid>
                </div>
                <MChatModal open={open} isFile={false} onClose={() => this._handleClose()} onSendMsg={(val) => this._onSendMsg(val)} />
                <Modal
                    open={this.state.showPopup}
                    onClose={() => this.onClose()}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    className={classes.modal}
                    style={{ position: 'fixed', bottom: 0, width: '100vw', height: 100 }}
                >
                    <div style={{ height: 165, width: '100%', position: 'fixed', bottom: 0, backgroundColor: '#fff', borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                        <div style={{ display: 'flex', margin: 25 }}>

                            {
                                AppData.ShareUrl && AppData.ShareUrl.length > 0 && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 30 }}>
                                    <CopyToClipboard text={AppData.ShareUrl} onCopy={this.onCopy}>
                                        <ButtonBase onClick={() => this.onPrivateClick()} >
                                            <img src={Popup0} style={{ width: 40, height: 40 }}></img>
                                        </ButtonBase>
                                    </CopyToClipboard>
                                    <Typography style={{ fontSize: 12, color: '#878787', marginTop: 5 }}>分享比赛</Typography>
                                </div>
                            }
                            {
                                copy_content && copy_content.length > 0 && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 30 }}>
                                    <CopyToClipboard text={copy_content} onCopy={this.onCopy}>
                                        <ButtonBase className={classes.copyButton} onClick={() => this.onCopy()}>
                                            <img src={Popup1} style={{ width: 40, height: 40, }}></img>
                                        </ButtonBase>
                                    </CopyToClipboard>
                                    <Typography style={{ fontSize: 12, color: '#878787', marginTop: 5 }}>复制</Typography>
                                </div>
                            }

                            <div onClick={() => this._onClickMessage()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 30 }}>
                                <img src={Popup2} style={{ width: 40, height: 40 }}></img>
                                <div style={{ color: '#878787', fontSize: 12, marginTop: 6 }}>
                                    私信
                                </div>
                            </div>


                        </div>
                    </div>
                </Modal>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={snackmessage}
                    autoHideDuration={2000}>
                </Snackbar>
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    copyButtonGrid: {
        zIndex: 1,
        maxWidth: 60,
        position: 'fixed',
        right: 10,
        bottom: 120
    },
    closeButton: {
        zIndex: 1,
        position: 'absolute',
        right: 0,
        top: 28
    },
    bottomView: {
        width: '100vw',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    root: {
        width: '100%',
        height: '100%',
        backgroundColor: '#F5F5F5'
    },
    // back: {
    //     backgroundColor: 'tranparent',
    //     flex: 1,
    // },
    welcomeimg: {
        width: 18,
        height: 18,
        position: 'absolute',
        top: 0,
        left: 15,
        bottom: 0,
        margin: 'auto'//使其垂直居中
    },
    conming: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        color: '#FFF',
        fontSize: 12,
        backgroundColor: '#B080FF',
        borderRadius: 30,
        marginLeft: 8,
        marginRight: 8,
        maxWidth: '75vw',
        display: 'flex',
        lineHeight: 2.4,
        marginTop: 10,
        // position: 'relative',

    },
    welcome: {
        marginRight: 5,
        marginLeft: 30
    },
    inputBack: {
        backgroundColor: '#EDEDED',
        borderRadius: 17.5,
        flexWrap: 'nowrap',
        height: 30,
        marginLeft: 8,
        width: "65vw"
    },
    input: {
        outline: 'none',
        border: 0,
        marginLeft: 16,
        backgroundColor: 'transparent',
        height: 30,
        flex: 1,
        fontSize: 12,
        maxWidth: 'calc(65vw - 40px)'
    },
    sendMsg: {
        height: 30,
        width: 70,
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        width: 20,
        height: 20,
        marginRight: 8,
        // marginBottom: 3
    },
}))(MovieChat));